import router from './router';
import store from './store';

const whiteList = ['/loginIndex', '/forgetPwd', '/reg', '/queryGrade','/grade']; // 不重定向白名单

router.beforeEach((to, _from, next) => {
  const isLoggedIn = store.state.user.uid; // 更清晰的登录状态变量名

  // 如果在白名单中，直接放行
  if (whiteList.indexOf(to.path) !== -1) {
    return next();
  }

  // 未登录状态，重定向到登录页
  if (!isLoggedIn) {
    return next('/loginIndex');
  }

  // 已登录状态下的特殊路径处理
  if (to.path === '/loginIndex') {
    // 如果已登录但访问登录页，重定向到公司页
    return next('/');
  }

  // 默认放行
  next();
});

router.afterEach(() => {
  // NProgress.done() // 结束Progress
});
